export default {"src":"/_next/static/media/0xaC14864ce5A98aF3248Ffbf549441b04421247D3.9286ee24.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};